
export default function ServicesHero() {
  return (
    <section className="relative min-h-[70vh] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/45fa217dd0292ebac1300401d1e1b6f3.jpg"
          alt="Florida Energy Efficient Homes"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60"></div>
      </div>

      <div className="relative z-10 max-w-[1400px] mx-auto px-6 py-32 w-full text-center">
        <span className="inline-block bg-brand-red/90 text-white text-sm font-bold px-5 py-2 rounded-full mb-6 tracking-wide">
          COMPREHENSIVE HOME ENERGY SOLUTIONS
        </span>
        <h1 className="text-5xl lg:text-7xl font-bold text-white mb-6 leading-tight max-w-4xl mx-auto">
          Expert Services For Every Florida Home
        </h1>
        <p className="text-xl text-white/90 max-w-2xl mx-auto mb-10 leading-relaxed">
          From solar panels to HVAC systems, attic insulation to solar fans — we deliver complete
          energy efficiency upgrades backed by 15+ years of Florida expertise.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href="#solar-installation"
            className="bg-brand-red text-white px-8 py-4 rounded-full text-base font-semibold hover:bg-brand-red-dark transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer shadow-lg"
          >
            Explore Our Services
          </a>
          <a
            href="tel:+18005551234"
            className="bg-white/10 backdrop-blur-sm border-2 border-white/40 text-white px-8 py-4 rounded-full text-base font-semibold hover:bg-white hover:text-brand-navy transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-line mr-2"></i>
            (800) 555-1234
          </a>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 mt-16 max-w-4xl mx-auto">
          {[
            { number: "15+", label: "Years Experience" },
            { number: "44,000+", label: "Homes Served" },
            { number: "60%", label: "Avg. Energy Savings" },
            { number: "25yr", label: "Warranty Coverage" },
          ].map((stat) => (
            <div
              key={stat.label}
              className="bg-white/10 backdrop-blur-sm rounded-2xl p-5 border border-white/20"
            >
              <p className="text-3xl font-bold text-white mb-1">{stat.number}</p>
              <p className="text-sm text-white/80">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
